// src/components/WildernessView.js
import React, { useState, useContext } from 'react'; 
import styles from './WildernessView.module.css';
import WildernessActionsPanel from './WildernessActionsPanel';
import WildernessInfoPanel from './WildernessInfoPanel';
import { MessageLogContext } from '../contexts/MessageLogContext'; 

const WILDERNESS_TABS = {
  GATHERING: 'gathering',
  ACTIVITIES: 'activities', 
  COMBAT: 'combat'
};

const WildernessView = ({ playerData, worldState, onPlayerAction }) => {
  const [selectedMonsterKey, setSelectedMonsterKey] = useState(null);
  const [activeTab, setActiveTab] = useState(WILDERNESS_TABS.GATHERING);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const { addMessage } = useContext(MessageLogContext); 

  const handleFightSelectedMonster = () => {
      if (selectedMonsterKey) {
          addMessage(`Preparing to fight ${selectedMonsterKey}...`, 'info'); 
          // The 'fightMonster' action key is now handled in Layout.js to initiate combat
          onPlayerAction('fightMonster', { monsterKey: selectedMonsterKey }); 
      } else {
          addMessage("No monster selected to fight.", 'warning'); 
      }
  };

  return (
    <div className={styles.wildernessViewContainer}>
      <div className={styles.leftPanel}>
        <div className={styles.tabButtons}>
          <button 
            className={`${styles.tabButton} ${activeTab === WILDERNESS_TABS.GATHERING ? styles.active : ''}`}
            onClick={() => setActiveTab(WILDERNESS_TABS.GATHERING)}
          >
            🌿 Gathering
          </button>
          <button 
            className={`${styles.tabButton} ${activeTab === WILDERNESS_TABS.ACTIVITIES ? styles.active : ''}`}
            onClick={() => setActiveTab(WILDERNESS_TABS.ACTIVITIES)}
          >
            🎣 Activities
          </button>
          <button 
            className={`${styles.tabButton} ${activeTab === WILDERNESS_TABS.COMBAT ? styles.active : ''}`}
            onClick={() => setActiveTab(WILDERNESS_TABS.COMBAT)}
          >
            ⚔️ Combat
          </button>
        </div>
        <WildernessActionsPanel
          onPlayerAction={onPlayerAction} 
          onSelectMonster={setSelectedMonsterKey}
          selectedMonsterKey={selectedMonsterKey}
          playerData={playerData}
          activeTab={activeTab}
          selectedActivity={selectedActivity}
          onSelectActivity={setSelectedActivity}
        />
      </div>
      <div className={styles.rightPanel}>
        <WildernessInfoPanel
          playerData={playerData}
          selectedMonsterKey={selectedMonsterKey}
          onFightAction={handleFightSelectedMonster}
          onPlayerAction={onPlayerAction}
          activeTab={activeTab}
          selectedActivity={selectedActivity}
        />
      </div>
    </div>
  );
};

export default WildernessView;